var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 600,
    viewBox: "0 0 360 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grain",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#485563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#29323c"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 600,
    fill: "url(#grain)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(255,255,255,0.4)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 0,
    x2: 25,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 0,
    x2: 85,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 0,
    x2: 145,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 0,
    x2: 205,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270,
    y1: 0,
    x2: 265,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330,
    y1: 0,
    x2: 325,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 50,
    x2: 55,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 50,
    x2: 115,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 50,
    x2: 175,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 50,
    x2: 235,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 50,
    x2: 295,
    y2: 80
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.b03903e02b99341950fcd42b977f3174.svg";
export { ForwardRef as ReactComponent };